import React from "react";
import { WithAuthorization, WithoutAuthorization } from "./Authorization";
import BaseRouter from "./BaseRouter";
import AuthRouter from "./AuthRouter";
import { createBrowserRouter, Navigate } from "react-router-dom";

import JoinPage from "~/pages/auth/JoinPage";
import JoinConfirmPage from "~/pages/auth/JoinPage/JoinConfirm";
import LoginPage from "~/pages/auth/LoginPage";
import FindPwPage from "~/pages/auth/FindPwPage/Find";
import ChangePwPage from "~/pages/auth/FindPwPage/Change";

import DashboardPage from "~/pages/DashboardPage";

import AlarmPage from "~/pages/alarm";

// Mypage
import AccountPage from "~/pages/mypage/AccountPage";
import PasswordPage from "~/pages/mypage/PasswordPage";
import SignaturePage from "~/pages/mypage/SignaturePage";
// import AlarmPage from "~/pages/mypage/AlarmPage";
// import PluginPage from "~/pages/mypage/PluginPage";
import NotFoundPage from "~/pages/NotFoundPage";
import AdminTeamPage from "~/pages/mypage/admin/TeamPage";
import AdminAuthPage from "~/pages/mypage/admin/AuthPage";
import AdminConnectPage from "~/pages/mypage/admin/ConnectPage";
import AdminBusinessPage from "~/pages/mypage/admin/BusinessPage";
import AdminSignaturePage from "~/pages/mypage/admin/SignaturePage";
import AdminLogoPage from "~/pages/mypage/admin/LogoPage";
import AdminLicensePage from "~/pages/mypage/admin/LicensePage";
import AdminPaymentPage from "~/pages/mypage/admin/PaymentPage";
import AdminPaymentHistoryPage from "~/pages/mypage/admin/PaymentPage/historyView";
import CallbackPage from "~/pages/mypage/admin/LicensePage/callback";

//invest
import InvestListPage from "~/pages/investment/InvestListPage";
import InvestFavoritePage from "~/pages/investment/InvestFavoritePage";
import InvestEvalPage from "~/pages/investment/InvestEvalPage";
import InvestHistoryPage from "~/pages/investment/InvestHistoryPage";
import InvestSettingPage from "~/pages/investment/InvestSettingPage";

//vcInfo
import VcInformation from "~/pages/vcInfo/VcInformation";
import VcMember from "~/pages/vcInfo/VcMember";

//portfolio
import PortfolioList from "~/pages/portfolio/PortfolioList";
import PortfolioView from "~/pages/portfolio/PortfolioView";
import PortfolioEdit from "~/pages/portfolio/PortfolioEdit";
import PortfolioCreate from "~/pages/portfolio/PortfolioCreate";

//round
import RoundList from "~/pages/round/RoundList";
import RoundReg from "~/pages/round/RoundReg/index";
import RoundManage from "~/pages/round/RoundManage";
import RoundSetting from "~/pages/round/RoundSetting";
import RoundResult from "~/pages/round/RoundManage/Result/roundResult";
import ApplyResult from "~/pages/round/RoundManage/Result/applyResult";
import EvaluatePage from "~/pages/round/RoundList/evaluate";
import Login from "~/pages/round/external/login"; // 외부링크 로그인
import Evaluate from "~/pages/round/external/evaluate"; // 외부링크 상세

//apply
import ApplyEval from "~/pages/apply/ApplyEval";
import ApplyManage from "~/pages/apply/ApplyManage";
import ApplySetting from "~/pages/apply/ApplySetting";
import Request from "~/pages/investment/InvestEvalPage/evalRequest/request";
import EvaluateDetailPage from "~/pages/investment/InvestEvalPage/detail";
import ApplyForm from "~/pages/apply/ApplyForm";
import ApplyFormMange from "~/pages/applyFormMange";
import InsertApplyForm from "~/pages/applyFormMange/InsertApplyForm";
import ApplyFaq from "~/pages/applyFormMange/ApplyFAQ";

import StartupApply from "~/pages/applyStartupForm";
import InternalServerError from "~/pages/InternalServerError";
import { PrivacyPolicy, TermsOfUse } from "~/pages/auth/JoinPage/components/policy";

// review setting
import Setting from "~/pages/review/setting";

// management
import Profile from "~/pages/management/profile";
import License from "~/pages/management/license";
import Payment from "~/pages/management/payment";
import Password from "~/pages/management/pw";

import Plugin from "~/pages/plugin";

const RouterObject = [
	{
		path: "join/confirm",
		element: <JoinConfirmPage />,
		withAuthorization: false,
		restricted: false,
	},
	{ path: "findpw/find", element: <FindPwPage />, withAuthorization: false, restricted: false },
	{
		path: "findpw/change",
		element: <ChangePwPage />,
		withAuthorization: false,
		restricted: false,
	},
	{ path: "externalRound/:idx", element: <Login />, withAuthorization: false, restricted: false }, // 외부링크 로그인
	{
		path: "externalRoundDetail/:idx",
		element: <Evaluate />,
		withAuthorization: false,
		restricted: false,
	}, // 외부링크 상세
	{
		path: "startup/apply/:idx",
		element: <StartupApply />,
		withAuthorization: false,
		restricted: false,
	},
	{ path: "", element: <LoginPage />, withAuthorization: false, restricted: true },
	{ path: "join", element: <JoinPage />, withAuthorization: false, restricted: true },
	{
		path: "applyForm",
		children: [
			{ path: "view", element: <InsertApplyForm />, withAuthorization: true },
			{ path: "edit", element: <ApplyFormMange />, withAuthorization: true },
			{ path: "editfaq", element: <ApplyFaq />, withAuthorization: true },
		],
	},
	{ path: "alarm/list", element: <AlarmPage />, withAuthorization: true },
	{ path: "dashboard", element: <DashboardPage />, withAuthorization: true },
	{ path: "plugin/list", element: <Plugin />, withAuthorization: true },
	{
		path: "500",
		element: <InternalServerError type="main" />,
		withAuthorization: true,
		restricted: true,
	},
	{
		path: "404",
		element: <NotFoundPage type="main" />,
		withAuthorization: true,
		restricted: true,
	},
	{
		path: "mypage",
		children: [
			{ path: "account/profile", element: <AccountPage />, withAuthorization: true },
			{ path: "account/pw", element: <PasswordPage />, withAuthorization: true },
			{ path: "account/signature", element: <SignaturePage />, withAuthorization: true },
			// { path: "alarm/list", element: <AlarmPage />, withAuthorization: true },
			// { path: "plugin/list", element: <PluginPage />, withAuthorization: true },
			{ path: "admin/team", element: <AdminTeamPage />, withAuthorization: true },
			{ path: "admin/auth", element: <AdminAuthPage />, withAuthorization: true },
			{ path: "admin/connect", element: <AdminConnectPage />, withAuthorization: true },
			{ path: "admin/business", element: <AdminBusinessPage />, withAuthorization: true },
			{ path: "admin/signature", element: <AdminSignaturePage />, withAuthorization: true },
			{ path: "admin/logo", element: <AdminLogoPage />, withAuthorization: true },
			{
				path: "admin/license",
				withAuthorization: true,
				children: [
					{
						path: "",
						element: <AdminLicensePage />,
						withAuthorization: true,
						hasBaseRouter: true,
					},
					{
						path: "success",
						element: <CallbackPage info="success" />,
						withAuthorization: true,
						hasBaseRouter: true,
					},
					{
						path: "fail",
						element: <CallbackPage info="fail" />,
						withAuthorization: true,
						hasBaseRouter: true,
					},
				],
			},
			{
				path: "admin/payment",
				withAuthorization: true,
				children: [
					{
						path: "",
						element: <AdminPaymentPage />,
						withAuthorization: true,
						hasBaseRouter: true,
					},
					{
						path: "detail/:idx",
						element: <AdminPaymentHistoryPage />,
						withAuthorization: true,
						hasBaseRouter: true,
					},
				],
			},
			{ path: "404", element: <NotFoundPage type="myPage" />, withAuthorization: true },
			{ path: "/mypage/*", element: <Navigate to="404" />, withAuthorization: true },
		],
	},
	{
		path: "invest",
		children: [
			{ path: "list", element: <InvestListPage />, withAuthorization: true },
			{ path: "favorite", element: <InvestFavoritePage />, withAuthorization: true },
			{ path: "evaluate", element: <InvestEvalPage /> },
			{
				path: "evaluate/detail/:idx",
				element: <EvaluateDetailPage />,
				withAuthorization: true,
			},
			{ path: "evaluate/request/:idx", element: <Request />, withAuthorization: true },
			{ path: "history", element: <InvestHistoryPage />, withAuthorization: true },
			{ path: "setting", element: <InvestSettingPage />, withAuthorization: true },
		],
	},
	{
		path: "vc",
		children: [
			{ path: "info", element: <VcInformation />, withAuthorization: true },
			{ path: "member", element: <VcMember />, withAuthorization: true },
			{ path: "member/:tab", element: <VcMember />, withAuthorization: true },
		],
	},
	{
		path: "portfolio",
		children: [
			{ path: "list", element: <PortfolioList />, withAuthorization: true },
			{ path: "view/:idx", element: <PortfolioView />, withAuthorization: true },
			{ path: "edit/:idx", element: <PortfolioEdit />, withAuthorization: true },
			{ path: "create", element: <PortfolioCreate />, withAuthorization: true },
		],
	},
	{
		path: "round",
		children: [
			{ path: "list", element: <RoundList />, withAuthorization: true },
			{ path: "register", element: <RoundReg />, withAuthorization: true },
			{ path: "management", element: <RoundManage />, withAuthorization: true },
			{ path: "setting", element: <RoundSetting />, withAuthorization: true },
			{ path: "result/apply", element: <ApplyResult />, withAuthorization: true },
			{ path: "result/round/:idx", element: <RoundResult />, withAuthorization: true },
			{ path: "list/evaluate/:idx", element: <EvaluatePage />, withAuthorization: true },
		],
	},
	{
		path: "apply",
		children: [
			{ path: "evaluate", element: <ApplyEval />, withAuthorization: true },
			{ path: "evaluate/:idx", element: <ApplyEval />, withAuthorization: true },
			{ path: "management", element: <ApplyManage />, withAuthorization: true },
			{ path: "setting", element: <ApplySetting />, withAuthorization: true },
			{ path: "form", element: <ApplyForm />, withAuthorization: true },
		],
	},
	{
		path: "review",
		children: [
			{ path: "setting", element: <Setting />, withAuthorization: true },
		],
	},
	{
		path: "management",
		children: [
			{ path: "profile", element: <Profile />, withAuthorization: true },
			{ path: "pw", element: <Password />, withAuthorization: true },
			{ path: "license", element: <License />, withAuthorization: true },
			{ path: "payment", element: <Payment />, withAuthorization: true },
		],
	},
	{ path: "*", element: <Navigate to="404" /> },
];

const commonRouter = (router) => ({
	path: router.path,
	element: router.element ? (
		router.withAuthorization ? (
			<WithAuthorization>
				<BaseRouter />
				<AuthRouter />
				{router.element}
			</WithAuthorization>
		) : (
			<WithoutAuthorization restricted={router.restricted}>
				<BaseRouter />
				{router.element}
			</WithoutAuthorization>
		)
	) : null,
});

const hasChildren = (router) => ({
	...commonRouter(router),
	children: router.children.map((item) => isChildrenMap(item)),
});

const hasntChildren = (router) => commonRouter(router);

const isChildrenMap = (router) => {
	if (!router.children) return hasntChildren(router);
	return hasChildren(router);
};

export const routers = createBrowserRouter(
	RouterObject.map((router) => {
		return {
			...commonRouter(router),
			children: router.children ? router.children.map((item) => isChildrenMap(item)) : [],
		};
	})
);
